<template>
  <div id="hres82e-calendar" class="hres82e-calendar">
    <div class="">
      <calendar-year :selectingYear="selectingYear"
                    :setSelectYear="setSelectYear" />
      <!-- Section Month -->
      <ul class="month">
        <li v-for="index in 12" :id="index"
            :class="{ 'current-month' : index == selectingMonth }"
            v-on:click="setSelectMonth(index)">{{ month[index-1].short }}</li>
      </ul>

      <!-- Section Weekdays -->
      <div class="table-calendar">
        <table class="table table-bordered" align="center" id="calendar-date">
          <thead class="weekdays">
            <tr>
              <th v-for="index_day in 7"
                  :id="index_day">
                  {{ days[index_day - 1] }}
              </th>
            </tr>
          </thead>
          <!-- Section days -->
          <tbody class="days">
            <template v-for="week in totalWeek">
              <week-row :arrWeek="calArrWeek(week)"
                        :setSelectDate="setSelectDate"
                        :checkCurrentDay="checkCurrentDay"
                        :checkSelectedDay="checkSelectedDay"
                        :selectedMonth="selectedMonth"
                        :selectedYear="selectedYear"
                        :selectingYear="selectingYear"
                        :selectingMonth="selectingMonth"
                        :calendar="calendar" />
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import weekRow from 'components/hres82e/weekRow'
import calendarYear from 'components/hres82e/year'

export default {
  name: 'hres82e-calendar',
  data () {
    return {
      currentYear: this.defaultDate.currentYear,
      currentMonth: this.defaultDate.currentMonth,
      currentDate: this.defaultDate.currentDate,
      currentDay: this.defaultDate.currentDay,
      selectingYear: this.defaultDate.currentYear,
      selectingMonth: this.defaultDate.currentMonth,
      selectedYear: this.defaultDate.currentYear,
      selectedMonth: this.defaultDate.currentMonth,
      selectedDate: this.defaultDate.currentDate,
      selectedDay: this.defaultDate.currentDay
    }
  },
  props: [ 'days', 'month', 'defaultDate', 'calendar', 'setDateSelected', 'toggle' ],
  watch: {
    defaultDate () {
      this.currentYear = this.defaultDate.currentYear
      this.currentMonth = this.defaultDate.currentMonth
      this.currentDate = this.defaultDate.currentDate
      this.currentDay = this.defaultDate.currentDay
      this.selectingYear = this.defaultDate.currentYear
      this.selectingMonth = this.defaultDate.currentMonth
      this.selectedYear = this.defaultDate.currentYear
      this.selectedMonth = this.defaultDate.currentMonth
      this.selectedDate = this.defaultDate.currentDate
      this.selectedDay = this.defaultDate.currentDay
    }
  },
  computed: {
    totalWeek () {
      return Math.ceil((this.firstDate + this.sumDayInMonth) / 7)
    },
    firstDate () {
      return Number(moment(moment().format(this.selectingYear + '-' + _.padStart(this.selectingMonth, 2, '0') + '-01'), 'YYYY-MM-DD').format('e'))
    },
    sumDayInMonth () {
      return moment(moment().format(this.selectingYear + '-' + _.padStart(this.selectingMonth, 2, '0') + '-01'), 'YYYY-MM-DD').daysInMonth()
    }
  },
  methods: {
    checkCurrentDay (day) {
      return (parseInt(this.currentMonth) === parseInt(this.selectingMonth) &&
             parseInt(this.currentYear) === parseInt(this.selectingYear) &&
             parseInt(this.currentDate) === parseInt(day))
    },
    checkSelectedDay (day) {
      return (parseInt(this.selectedMonth) === parseInt(this.selectingMonth) &&
             parseInt(this.selectedYear) === parseInt(this.selectingYear) &&
             parseInt(this.selectedDate) === parseInt(day))
    },
    calArrWeek (week) {
      var dayStartInRow = 1 + (week - 1) * 7
      if (week > 1) {
        dayStartInRow = dayStartInRow - this.firstDate
      }
      var arrWeek = []
      for (var i = 1; i <= 7; i++) {
        if (week === 1 && i <= this.firstDate) {
          for (var j = 1; j <= this.firstDate; j++) {
            arrWeek.push('')
            i++
          }
        }

        if (dayStartInRow <= this.sumDayInMonth) {
          arrWeek.push(dayStartInRow)
          dayStartInRow++
        } else {
          arrWeek.push('')
        }
      }
      return arrWeek
    },
    setSelectYear (year) {
      this.selectingYear = parseInt(this.selectingYear) + parseInt(year)
      this.genCalendar()
    },
    setSelectMonth (month) {
      this.selectingMonth = month
      if (!this.calendarSwitch) { // monthMode
        this.selectedYear = this.selectingYear
        this.selectedMonth = month
      }
      this.genCalendar()
    },
    setSelectDate (objDate) {
      this.selectedYear = this.selectingYear
      this.selectedMonth = this.selectingMonth
      this.selectedDate = objDate.date
      this.selectedDay = objDate.day
      this.genCalendar()
    },
    genCalendar () {
      this.setDateSelected(_.padStart(this.selectedDate, 2, '0') + '/' + _.padStart(this.selectedMonth, 2, '0') + '/' + _.padStart(this.selectedYear, 2, '0'))
      this.toggle('detail')
    }
  },
  components: {
    weekRow,
    calendarYear
  }
}
</script>


// WEBPACK FOOTER //
// calendar.vue?7c58bc66